import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

export function Footer(props) {
  const { t } = useTranslation();

  return (
    <div className="modal-footer">
      <div
        style={{
          justifySelf: "flex-start",
          marginRight: "auto",
        }}
      >
        <p>
          {t(
            Object.hasOwn(props.modalData, "pIndex") &&
              Object.hasOwn(props.modalData, "tIndex")
          )
            ? "HitNext.string"
            : "HitFinish.string"}
        </p>
      </div>
      <button
        aria-label={t("Done")}
        tabIndex={props.tab}
        className="modal-btn-primary"
        onClick={() => props.finishStep()}
      >
        {t(
          Object.hasOwn(props.modalData, "pIndex") &&
            Object.hasOwn(props.modalData, "tIndex")
        )
          ? "NextStep.string"
          : "FinishStep.string"}
      </button>
    </div>
  );
}

Footer.propTypes = {
  /**
   * specified callback function when step finishes
   */
  finishStep: PropTypes.func,

  modalData: PropTypes.any,

  lang: PropTypes.oneOf([
    "en",
    "ar",
    "ja",
    "nl",
    "de",
    "es",
    "fr",
    "it",
    "ko",
    "pt",
    "tr",
    "zh",
    "zu",
  ]),
};
